'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'boombox';
var width = 576;
var height = 512;
var aliases = [128254];
var unicode = 'f8a5';
var svgPathData = 'M56 0l-24 0 0 160-32 0 0 320 576 0 0-320-32 0 0-160-488 0zM496 160l-80 0 0-32-64 0 0 32-32 0 0-32-64 0 0 32-32 0 0-32-64 0 0 32-80 0 0-112 416 0 0 112zM224 208l304 0 0 224-480 0 0-224 176 0zm-48 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoombox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;